/* eslint-disable no-unused-expressions */

import React, { useState, useEffect } from 'react';
import './style.scss';
import clsx from 'clsx';
import { FormControlLabel } from '@mui/material';
import { styled } from '@mui/material/styles';
import Checkbox from '@mui/material/Checkbox';
import SliderRange from '../SliderRange';
import SortingComponent from '../Sorting';
import Button from '../../Shared/components/controls/Button';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
//component
//images
const icon_angleDown_blue =
  '/-/jssmedia/Project/FAB2/shared/images/icon_angle-down-filter-blue.svg';
const icon_closeTag = '/-/jssmedia/Project/FAB2/shared/images/icon_close-tag-blue.svg';

const iconCheckboxWhite = '/-/jssmedia/Project/FAB2/shared/images/icon_checkbox-check-white.svg'; //filter components

var year = new Date().getFullYear();
var month = new Date().getMonth();
let firstOfThisMonthDate = new Date(year, month, 1);

/***Component***/
const FilterComponent = ({
  props,
  t,
  selectSortValue,
  setSelectSortValue,
  selectSortText,
  setSelectSortText,
  enableDiscountPercentage,
  setAllFilters,
  allFilters,
  sliderProps,
  minDiscount,
  maxDiscount,
  externalReset,
  mobileFiltersIsToggle,
  setMobileFiltersIsToggle,
}) => {
  //checked variable
  const cuisines = props?.fields?.cuisines;
  const locations = props?.fields?.locations;
  const sorting = props?.fields?.sorting;

  var cards = [];
  props?.fields?.cards?.map((card) => {
    cards.push({
      id: card.id,
      fields: {
        name: card?.name,
        displayName: card?.displayName,
        DropdownText: { value: card?.fields?.heading?.value },
        DropdownValue: { value: card?.fields?.heading?.value },
        url: card?.url,
      },
    });
  });

  const context = useSitecoreContext();
  const offerTags = context?.sitecoreContext?.route?.fields;

  //rendering
  const shouldRenderLocation = Array.isArray(locations) && locations?.length > 0;
  const shouldRenderCuisine = Array.isArray(cuisines) && cuisines?.length > 0;
  const shouldRenderSorting = Array.isArray(sorting) && sorting?.length > 0;
  const shouldRenderCardsFilter = Array.isArray(cards) && cards?.length > 0;
  const shouldRenderOfferTags = Array.isArray(offerTags) && offerTags?.length > 0;

  const BpIcon = styled('span')(({ theme }) => ({
    borderRadius: 4,
    width: 20,
    height: 20,
    boxShadow:
      theme.palette.mode === 'dark'
        ? '0 0 0 1px rgb(16 22 26 / 40%)'
        : 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundColor: theme.palette.mode === 'dark' ? '#394b59' : '#f5f8fa',
    backgroundImage:
      theme.palette.mode === 'dark'
        ? 'linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))'
        : 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
    '.Mui-focusVisible &': {
      outline: '2px auto rgba(19,124,189,.6)',
      outlineOffset: 2,
    },
    'input:hover ~ &': {
      backgroundColor: theme.palette.mode === 'dark' ? '#30404d' : '#ebf1f5',
    },
    'input:disabled ~ &': {
      boxShadow: 'none',
      background: theme.palette.mode === 'dark' ? 'rgba(57,75,89,.5)' : 'rgba(206,217,224,.5)',
    },
  }));

  const BpCheckedIcon = styled(BpIcon)({
    backgroundColor: '#137cbd',
    backgroundImage: 'linear-gradient(105.18deg, #003DA6 3.44%, #2669DC 97.48%)',
    '&:before': {
      display: 'block',
      width: 20,
      height: 20,
      backgroundImage: `url('${iconCheckboxWhite}')`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      content: '""',
    },
    'input:hover ~ &': {
      backgroundColor: '#106ba3',
    },
  });

  const [resetSliderRangeDiscount, setResetSliderRangeDiscount] = useState(false);
  useEffect(() => {
    setResetSliderRangeDiscount(externalReset);
  }, [externalReset]);

  // Inspired by blueprintjs
  const BpCheckbox = (props) => {
    return (
      <Checkbox
        sx={{
          '&:hover': { bgcolor: 'transparent' },
        }}
        // disableRipple
        color="default"
        checkedIcon={<BpCheckedIcon />}
        icon={<BpIcon />}
        inputProps={{ 'aria-label': 'Checkbox demo' }}
        {...props}
      />
    );
  };
  //remove tags from filter
  const removeTagFromFilter = (type, id) => {
    //unpush
    if (type === 'location') {
      setAllFilters((prev) => {
        return {
          ...prev,
          tagFilter: prev.tagFilter.filter((elt) => elt.id !== id),
          locationFilter: prev.locationFilter.filter((elt) => elt !== id),
          selectedLocationsIDForGraphGql: prev.selectedLocationsIDForGraphGql.filter(
            (elt) => elt !== id?.replace(/-/g, '')
          ),
        };
      });
    } else if (type === 'offertags') {
      setAllFilters((prev) => {
        return {
          ...prev,
          tagFilter: prev.tagFilter.filter((elt) => elt.id !== id),
          offerTagsFilter: prev.offerTagsFilter.filter((elt) => elt !== id),
          selectedOfferTagsIDForGraphGql: prev.selectedOfferTagsIDForGraphGql.filter(
            (elt) => elt !== id?.replace(/-/g, '')
          ),
        };
      });
    } else if (type === 'cuisine') {
      setAllFilters((prev) => {
        return {
          ...prev,
          tagFilter: prev.tagFilter.filter((elt) => elt.id !== id),
          cuisineFilter: prev.cuisineFilter.filter((elt) => elt !== id),
          selectedCuisineIDForGraphGql: prev.selectedCuisineIDForGraphGql.filter(
            (elt) => elt !== id?.replace(/-/g, '')
          ),
        };
      });
    } else if (type === 'cards') {
      setAllFilters((prev) => {
        return {
          ...prev,
          tagFilter: prev.tagFilter.filter((elt) => elt.id !== id),
          cardsFilter: prev.cardsFilter.filter((elt) => elt !== id),
          selectedCardsIDForGraphGql: prev.selectedCardsIDForGraphGql.filter(
            (elt) => elt !== id?.replace(/-/g, '')
          ),
        };
      });
    } else if (type === 'cards') {
      setAllFilters((prev) => {
        return {
          ...prev,
          tagFilter: [...prev.tagFilter, { id: id, type }], //title: title, 
          cardsFilter: [...prev.cardsFilter, id],
          selectedCardsIDForGraphGql: [...prev.selectedCardsIDForGraphGql, id?.replace(/-/g, '')],
        };
      });
    } else if (type === 'discount') {
      // setSliderRangeValues({ from: minDiscount?.value, to: maxDiscount?.value, id: 'discount' });
      //we unpush from here but we push from the on change method
      setAllFilters((prev) => {
        return {
          ...prev,
          tagFilter: prev.tagFilter.filter((elt) => elt.type !== 'discount'),
          discountFilter: { from: minDiscount?.value, to: maxDiscount?.value, id: 'discount' },
        };
      });

      setResetSliderRangeDiscount((prev) => !prev);
    } else if (type === 'yearMonthPicker') {
      //unpush all tags [it will be only one]

      setAllFilters((prev) => {
        return {
          ...prev,
          tagFilter: prev?.tagFilter?.filter((elt) => elt.type !== type),
          validityFilter: { from: firstOfThisMonthDate, to: allFilters?.validityFilterEndDate },
        };
      });
    }
  };
  //Fitler Tag Component
  const FitlerTagComponent = ({ item }) => {
    return (
      <div className="tag-filter flex-inline">
        <div className="tag-name flex-align-item-center flex-it flex-justify-center">
          {item.title}
        </div>
        <div
          className="tag-close flex-align-item-center flex-it flex-justify-center"
          onClick={() => removeTagFromFilter(item?.type, item?.id)}
        >
          <img src={icon_closeTag} />
        </div>
      </div>
    );
  };

  //Filter Dropdown Component
  const FilterDropdownComponent = ({ type, title, items, isOpen, theme, setOpen }) => {
    let checked = false;
    const openCloseDroprown = () => {
      if (setOpen) {
        setOpen();
      }
    };

    //click method
    const updateFilter = (id, type, title) => {
      //locations
      checked =
        checked ||
        allFilters?.locationFilter.some((elt) => elt === id) ||
        allFilters?.cuisineFilter.some((elt) => elt === id) ||
        allFilters?.cardsFilter.some((elt) => elt === id) ||
        allFilters?.offerTagsFilter.some((elt) => elt === id);
      if (checked) {
        //unpush
        removeTagFromFilter(type, id);
      } else {
        //push
        if (type === 'location') {
          setAllFilters((prev) => {
            return {
              ...prev,
              tagFilter: [...prev.tagFilter, { title: title, id: id, type }],
              locationFilter: [...prev.locationFilter, id],
              selectedLocationsIDForGraphGql: [
                ...prev.selectedLocationsIDForGraphGql,
                id?.replace(/-/g, ''),
              ],
            };
          });
        } else if (type === 'offertags') {
          setAllFilters((prev) => {
            return {
              ...prev,
              tagFilter: [...prev.tagFilter, { title: title, id: id, type }],
              offerTagsFilter: [...prev.offerTagsFilter, id],
              selectedOfferTagsIDForGraphGql: [
                ...prev.selectedOfferTagsIDForGraphGql,
                id?.replace(/-/g, ''),
              ],
            };
          });
        } else if (type === 'cuisine') {
          setAllFilters((prev) => {
            return {
              ...prev,
              tagFilter: [...prev.tagFilter, { title: title, id: id, type }],
              cuisineFilter: [...prev.cuisineFilter, id],
              selectedCuisineIDForGraphGql: [
                ...prev.selectedCuisineIDForGraphGql,
                id?.replace(/-/g, ''),
              ],
            };
          });
        } else if (type === 'cards') {
          setAllFilters((prev) => {
            return {
              ...prev,
              tagFilter: [...prev.tagFilter, { title: title, id: id, type }],
              cardsFilter: [...prev.cardsFilter, id],
              selectedCardsIDForGraphGql: [
                ...prev.selectedCardsIDForGraphGql,
                id?.replace(/-/g, ''),
              ],
            };
          });
        }
      }
    };
    return (
      <div
        className={clsx(
          'filter-item flex-inline filter-dropdown filter-align-dropdown-left',
          isOpen ? 'open' : ''
        )}
      >
        <div className="arrow-top"></div>
        <div className="filter-text-arrow" onClick={openCloseDroprown}>
          <div className="filter-text">{title}</div>
          <span className="filter-arrow-select-wrap flex-it flex-align-item-center">
            <img className="arrow-select show-on-open" src={icon_angleDown_blue} />
            <img className="arrow-select show-on-close" src={icon_angleDown_blue} />
          </span>
        </div>

        <div className={clsx('select custom-checkbox', theme)}>
          <div className="select-wrap">
            {items?.map((item, index) => {
              const label = item?.fields?.DropdownText?.value;
              const id = item?.id;
              const itemType = type;
              const onChangeHandle = () => {
                updateFilter(id, itemType, label);
              };
              return (
                <div className="checkbox-filter" key={index} onChange={onChangeHandle}>
                  <FormControlLabel
                    className="label-checkbox"
                    control={<BpCheckbox id={id}></BpCheckbox>}
                    checked={
                      allFilters?.locationFilter.some((elt) => elt === id) ||
                      allFilters?.cuisineFilter.some((elt) => elt === id) ||
                      allFilters?.cardsFilter.some((elt) => elt === id) ||
                      allFilters?.offerTagsFilter.some((elt) => elt === id)
                    }
                    label={label}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  };
  //filters
  const [filterOpen, setFilterOpen] = useState('');
  const checkIsOpen = (filterId) => {
    return filterOpen === filterId;
  };
  const changeFilter = (filterId) => {
    setFilterOpen(filterId === filterOpen ? '' : filterId);
  };
  const clearAllTags = () => {
    setAllFilters((prev) => {
      return {
        ...prev,
        reRender: !prev?.reRender,
        cuisineFilter: [],
        cardsFilter: [],
        locationFilter: [],
        offerTagsFilter: [],
        tagFilter: [],
        discountFilter: { from: minDiscount?.value, to: maxDiscount?.value },
        validityFilter: {
          from: firstOfThisMonthDate.toISOString(),
          to: allFilters?.validityFilterEndDate,
        },
        //date format:2021-12-31T16:00:00Z
        selectedLocationsIDForGraphGql: [],
        selectedCuisineIDForGraphGql: [],
        selectedCardsIDForGraphGql: [],
        selectedOfferTagsIDForGraphGql: [],
      };
    });
    setResetSliderRangeDiscount((prev) => !prev);
  };

  useEffect(() => {
    if (mobileFiltersIsToggle) {
      document.body.classList.add('filter-modal-open');
    } else {
      document.body.classList.remove('filter-modal-open');
    }
  }, [mobileFiltersIsToggle]);

  return (
    <div className={clsx(`filter-and-tags`, mobileFiltersIsToggle ? 'open' : '')}>
      <div className="filter-top-nav mobile">
        <div className="auto flex-it flex-align-item-center flex-justify-between">
          <div className="label-filter">{t('filterTitle')}</div>
          <div
            className="close-filters"
            onClick={() => setMobileFiltersIsToggle((state) => !state)}
          >
            <img src={'/-/jssmedia/Project/FAB2/shared/images/icon_close-blue.svg'} />
          </div>
        </div>
      </div>
      <div className="generic-filter">
        {shouldRenderOfferTags && (
          <FilterDropdownComponent
            items={offerTags}
            isOpen={checkIsOpen('offertags')}
            setOpen={() => changeFilter('offertags')}
            title={t('offerTagsFilterTitle')}
            type={'offertags'}
            theme={'center-arrow-dropdown'}
          />
        )}

        {shouldRenderLocation && (
          <FilterDropdownComponent
            items={locations}
            isOpen={checkIsOpen('locations')}
            setOpen={() => changeFilter('locations')}
            title={t('Location')}
            type={'location'}
          />
        )}

        {enableDiscountPercentage?.value === true && (
          <FilterSliderComponent
            isOpen={checkIsOpen('sliderRange')}
            setOpen={() => changeFilter('sliderRange')}
            title={t('offerCategoryFilterDiscountPercentage')}
            sliderProps={sliderProps}
            t={t}
            theme={'center-arrow-dropdown'}
            resetSliderRangeDiscount={resetSliderRangeDiscount}
          />
        )}
        {shouldRenderCardsFilter && (
          <FilterDropdownComponent
            items={cards}
            isOpen={checkIsOpen('cards')}
            setOpen={() => changeFilter('cards')}
            title={t('allCards')}
            type={'cards'}
            theme={'center-arrow-dropdown'}
          />
        )}

        {shouldRenderCuisine && (
          <FilterDropdownComponent
            items={cuisines}
            isOpen={checkIsOpen('cuisines')}
            setOpen={() => changeFilter('cuisines')}
            title={t('Cuisine')}
            type={'cuisine'}
            theme={'center-arrow-dropdown'}
          />
        )}

        {shouldRenderSorting && (
          <SortingComponent
            items={sorting}
            isOpen={false}
            mobileView={false}
            {...{
              selectSortValue,
              setSelectSortValue,
              selectSortText,
              setSelectSortText,
              setAllFilters,
              t,
            }}
          />
        )}
      </div>

      <div className="tags">
        {allFilters?.tagFilter?.length > 0 &&
          allFilters?.tagFilter?.map((item) => {
            return <FitlerTagComponent item={item} key={item.id} />;
          })}

        {allFilters?.tagFilter?.length > 0 && (
          <div className="clear-all-tags flex-inline" onClick={clearAllTags}>
            {t('clearAll')}
          </div>
        )}
      </div>

      <div className="mobile">
        <div className="filter-footer flex-it flex-align-item-center flex-justify-between">
          <div className="auto flex-it flex-align-item-center flex-justify-between">
            <div className="clear-all-tags flex-inline" onClick={clearAllTags}>
              {t('clearAll')}
            </div>

            <div className="view-all">
              <Button
                onClick={() => {
                  // handleKeywordSearchButtonClick;
                  setMobileFiltersIsToggle((state) => !state);
                }}
                fullWidth={false}
                variant="contained"
                className="panel-right__link search-btn btn-view-all"
              >
                {t('showResults')}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

//FilterSliderComponent
const FilterSliderComponent = ({
  title,
  isOpen,
  sliderProps,
  t,
  setOpen,
  resetSliderRangeDiscount,
}) => {
  const openCloseDroprown = () => {
    if (setOpen) {
      setOpen();
    }
  };

  return (
    <div
      className={clsx('filter-item flex-inline filter-dropdown center-arrow', isOpen ? 'open' : '')}
    >
      <div className="arrow-top"></div>
      <div className="filter-text-arrow" onClick={openCloseDroprown}>
        <div className="filter-text">{title}</div>
        <span className="filter-arrow-select-wrap flex-it flex-align-item-center">
          <img className="arrow-select show-on-open" src={icon_angleDown_blue} />
          <img className="arrow-select show-on-close" src={icon_angleDown_blue} />
        </span>
      </div>

      <div className={clsx('select slider-double')}>
        <div className="select-wrap">
          <SliderRange props={sliderProps} t={t} reset={resetSliderRangeDiscount} />
        </div>
      </div>
    </div>
  );
};

export default FilterComponent;
